interface VideoPlayerProps {
  folder: string;
  fileName: string;
}

const API_BASE = "https://api.growniverse.com/api";
import crypto from "crypto-js";

const SECRET_KEY = "5d928cd2-77d1-4415-growniverse-4f225f40ee65";

function generateSignature(payload) {
  const timestamp = Date.now().toString();
  const data = `${payload}|${timestamp}`;
  const signature = crypto
    .HmacSHA256(data, SECRET_KEY)
    .toString(crypto.enc.Hex);
  return { signature, timestamp };
}
export default function VideoPlayer({ folder, fileName }: VideoPlayerProps) {
  if (!folder || !fileName) {
    return (
      <div
        style={{
          width: "100%",
          minHeight: "180px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "12px",
          background: "#111",
          color: "#aaa",
          fontSize: "14px",
          textAlign: "center",
          padding: "16px",
          boxSizing: "border-box",
        }}
      >
        Video information is missing.
      </div>
    );
  }
  const { signature, timestamp } = generateSignature(folder+fileName);
  const videoUrl =
    `${API_BASE}/videos/` +
    `${encodeURIComponent(folder)}/` +
    `${encodeURIComponent(fileName)}/` +
    `${encodeURIComponent(timestamp)}/` +
    `${encodeURIComponent(signature)}`;

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "1400px",
        margin: "0 auto",
        padding: "8px",
        boxSizing: "border-box",
        background: "#0d0d0d",
        border: "1px solid #292929",
        borderRadius: "clamp(10px, 2vw, 18px)",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.45)",
      }}
    >
      <div
        style={{
          width: "100%",
          aspectRatio: "16 / 9",
          maxHeight: "78vh",
          overflow: "hidden",
          borderRadius: "clamp(7px, 1.5vw, 12px)",
          background: "#000",
        }}
      >
        <video
          key={videoUrl}
          controls
          controlsList="nodownload"
          playsInline
          preload="metadata"
          onContextMenu={(event) => event.preventDefault()}
          src={videoUrl}
          style={{
            display: "block",
            width: "100%",
            height: "100%",
            objectFit: "contain",
            background: "#000",
          }}
        >
          Your browser does not support video playback.
        </video>
      </div>
    </div>
  );
}
